import { useContext } from 'react';
import { hasFocusContext } from '../context';

export const useFocus = () => {
  const focusStateHandlers = useContext(hasFocusContext);
  return focusStateHandlers;
};
